// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2H6tH","inputWrap":"Table_inputWrap__2MYie","col":"Table_col__3FFrz","bmiTooltip":"Table_bmiTooltip__1scm2"};